// extracted by mini-css-extract-plugin
export default {"wrapper":"edit-push-consent__wrapper--wLjqK"};